<template>
  <nav
    aria-label="menu"
    class="bg-surface-default-low fixed inset-0 z-20 flex flex-col md:hidden"
  >
    <Header />
    <div class="flex-1 overflow-auto py-20">
      <MenuSection />
      <Footer />
    </div>
    <div class="border-static-default-low border-t px-20 py-12">
      <CountrySwitchMenuFullScreen />
    </div>
  </nav>
</template>

<script setup lang="ts">
import CountrySwitchMenuFullScreen from '../CountrySwitch/CountrySwitchMenuFullScreen.vue'

import Footer from './Footer.vue'
import Header from './Header.vue'
import MenuSection from './MenuSection.vue'
</script>
